import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { authAPI } from "../services/api";

export default function PrivateRoute({ children }) {
  const location = useLocation();
  const [verification, setVerification] = useState(null);
  const [retry, setRetry] = useState(0);
  const key = location.pathname;
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const check = async () => {
      if (!sessionStorage.getItem("token")) { setVerification({ key, authenticated: false }); return; }
      try {
        const { data } = await authAPI.check(controller.signal);
        if (active) setVerification({ key, authenticated: true, passwordChangeRequired: data.password_change_required });
      } catch (failure) {
        if (!active) return;
        if (failure.response?.status === 401 || failure.response?.status === 403) {
          sessionStorage.removeItem("token"); sessionStorage.removeItem("username");
          setVerification({ key, authenticated: false });
        } else setVerification({ key, error: true });
      }
    };
    check();
    return () => { active = false; controller.abort(); };
  }, [key, retry]);
  if (!verification || verification.key !== key) return <p role="status" className="p-8 text-center text-gray-500">Vérification de la session...</p>;
  if (verification.error) return <div className="space-y-4 p-8 text-center"><p role="alert">Impossible de vérifier la session. Vérifiez la connexion au serveur.</p><button className="btn-secondary" onClick={() => setRetry((value) => value + 1)}>Réessayer</button></div>;
  if (verification.passwordChangeRequired && key !== "/securite") return <Navigate to="/securite" replace />;
  return verification.authenticated ? children : <Navigate to="/login" replace />;
}
